// Phase 5Z.9 — Fahrer-Portal i18n setup
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import de from "./locales/de.json";
import en from "./locales/en.json";
import hu from "./locales/hu.json";
import sr from "./locales/sr.json";
import ro from "./locales/ro.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      de: { translation: de },
      en: { translation: en },
      hu: { translation: hu },
      sr: { translation: sr },
      ro: { translation: ro },
    },
    fallbackLng: "de",
    supportedLngs: ["de", "en", "hu", "sr", "ro"],
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "fahrer_lang",
    },
  });

export const SUPPORTED_LANGUAGES = [
  { code: "de", label: "Deutsch", flag: "🇩🇪" },
  { code: "en", label: "English", flag: "🇬🇧" },
  { code: "hu", label: "Magyar", flag: "🇭🇺" },
  { code: "sr", label: "Srpski", flag: "🇷🇸" },
  { code: "ro", label: "Română", flag: "🇷🇴" },
];

export default i18n;
